import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../users/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { Session } from './../../users/user.types';
import { Subscription } from 'rxjs/Rx';

import {TranslateService} from '@ngx-translate/core';
import { SharedService } from 'app/shared/shared.service';
import { AngularLoadingBarService } from 'ng4-loader-bar';
import { NavService } from './nav.service';


@Component({
  selector: 'b4a-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {
loggedIn = false;
sessionData; // session data from api
isSalesMode: boolean;

selectedLanguage;


// spinnerLoading: boolean = true;

userType; // ng model for user types
isServerAdmin:      Boolean = false; // true, if user is server admin with access for management
tenantCode:         String  = null;  // tenant code
tenantName:         String  = null;  // tenant name
loggedInAsSysAdmin: Boolean = false; // true, if user is logged in as sys admin of tenant


acceptedLanguages;
  constructor(private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private angularLoadingBarService: AngularLoadingBarService,
    private sharedService: SharedService,
    private navService: NavService
  ) {
    // translate.addLangs(['de_DE', 'fr_FR', 'en_UK']);
    translate.setDefaultLang('de_DE');
    // let browserLang = translate.getBrowserLang();
    // translate.use(browserLang.match(/en|fr|de/) ? browserLang : 'de')

    if (localStorage.getItem('sessionData') !== null) {


    let sessionData = JSON.parse(localStorage.getItem('sessionData'))
    if (typeof sessionData !== 'undefined') {
      if(sessionData.language !== ''){
        translate.use(sessionData.language)
        this.selectedLanguage = sessionData.language;
      }else{
        translate.use(sessionData.defaultLanguage)
        this.selectedLanguage = sessionData.defaultLanguage;
      }
      this.sessionData = sessionData
      this.isSalesMode = this.sessionData.isSalesMode
      this.userType = this.sessionData.homepage.type;
      this.isSalesMode = this.sessionData.isSalesMode
      this.sharedService.setUserType(this.userType)

    }
  }
  this.authService.getSession().subscribe(
    done => {
      if (typeof(done) === 'string') {
        this.userType = JSON.parse(done).homepage.type
        this.loggedIn = JSON.parse(done).isLoggedIn;
        this.sessionData = JSON.parse(done)
      }else {
        this.userType = done.homepage.type
        this.loggedIn = done.isLoggedIn;
        this.sessionData = done;
      }
    })
  }

  changeLanguage(language) {
    this.navService.setLanguage(language).subscribe(
      done => {
        let tempSessionData = JSON.parse(localStorage.getItem('sessionData'));
        tempSessionData.language = language;
        this.authService.setSession(tempSessionData);
        localStorage.setItem('sessionData', JSON.stringify(tempSessionData));
        this.translate.use(language);
        this.selectedLanguage = language;
      }
    );
  }


  ngOnInit() {
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd) { this.refreshHeader(); }
      }
    );

    let sessionData = localStorage.getItem('sessionData')
    if(sessionData !== null){

      let sesID = JSON.parse(sessionData)

      if (sesID.isLoggedIn === true) {
        this.loggedIn = true
      }else {
        this.loggedIn = false;
      }

    //  setInterval(() => {
    //   let sessionData = localStorage.getItem('sessionData')
    //   let sesID = JSON.parse(sessionData)
    //   if (sesID.isLoggedIn === true) {
    //     this.loggedIn = true
    //   }else {
    //     this.loggedIn = false;
    //   }
    //    }, 1000);
    }
  }

  /**
   * refresh header information (access to managemant, tenant name, etc.)
   */
  refreshHeader(): void {
    // determine if user is logged in as SysAdmin of tenant
    let sysAdmin = localStorage.getItem('loggedInAsSysAdmin');
    this.loggedInAsSysAdmin = (sysAdmin === 'true');
    // reload session data
    /*this.authService.refresh().subscribe(
      // success
      (session: Session) => {
        this.isServerAdmin = session.isServerAdmin;
        this.tenantCode    = session.tenantCode;
        this.tenantName    = session.tenantName;
      }
    );*/
  }
  changeUserType(userType) {
    if (this.isSalesMode === true) {
      this.router.navigate(['products/simpleTravels']);
      this.angularLoadingBarService.start();
      this.sessionData.homepage.type = userType
      this.sharedService.changeSessionData(this.sessionData).subscribe(session => {
        this.sharedService.setUserType(userType)
        this.userType = userType;
        this.authService.setSession(session);
        localStorage.setItem('sessionData', JSON.stringify(session))
        this.angularLoadingBarService.complete();
    });
    }
  }

  logout() {
    let sid = localStorage.getItem('sessionId');
    this.authService.logout().subscribe(
      // success
      (session: Session) => {
        // check if user is logged in yet
        // -> reset session id in storeage and go to tenant mangement because user was logged in as sysadmin
        if(session.isLoggedIn){
          localStorage.removeItem('loggedInAsSysAdmin');
          localStorage.setItem('sessionId',sid);
          this.router.navigate(['/config/tenants'])
        }
        else {
          this.router.navigate(['/login']);
          this.loggedIn = false;
          this.authService.refresh()
          localStorage.setItem('loggedIn', 'false')
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/nav/nav.component.ts